import { FC } from "react";

import { EmptyTopicBanner } from "components/materials/page/banners/EmptyTopicBanner";
import { t } from "i18n/i18n";

type NoPageViewProps = {
  showEmptyTopicBanner?: boolean;
};

// View to show when there are no pages in a course.
export const NoPageView: FC<NoPageViewProps> = ({ showEmptyTopicBanner = false }) => {
  if (showEmptyTopicBanner) {
    return (
      <div className="flex h-full w-full flex-col items-center px-4 pt-4 md:px-10">
        <EmptyTopicBanner className="max-w-[--page-default-max-width]" />
      </div>
    );
  }

  return (
    <div className="flex h-full w-full justify-center text-black-tint-40">
      <div className="mt-[200px]">
        <div className="flex flex-col items-center gap-3">
          <div>{t("page_detail_view.no_content")}</div>
        </div>
      </div>
    </div>
  );
};
